import React from 'react';
import { createSignPayloadMessage } from '../components/SignPayloadDialog/helpers/createSignPayloadMessage';
import { useWeb3 } from '../../../../../hooks/useWeb3';
import { createSignMultiCallMessage } from '../components/SignPayloadDialog/helpers/createSignMultiCallMessage';
import { EIP712TypedData } from '../../../../../utils/web3Provider';

interface SignSingleCallTypedData {
  rowData: any;
  rawTx: any;
  isTron: boolean;
  chainId: number;
  fromAddress: string;
}

interface IProps {
  signTypedDataWithWrappedPayload: (typedData: EIP712TypedData) => Promise<string>;
}

const useSingleCallSign = (props: IProps) => {
  const { signTypedDataWithWrappedPayload } = props;

  const signSingleCallTypedData = async (props: SignSingleCallTypedData) => {
    const { rowData, rawTx, isTron, chainId, fromAddress } = props;

    const signPayloadMessage = createSignPayloadMessage({
      rowData,
      rawTx,
      isTron,
    });

    const types = {
      Execute: [
        {
          name: 'from',
          type: 'address',
        },
        {
          name: 'to',
          type: 'address',
        },
        {
          name: 'value',
          type: 'uint256',
        },
        {
          name: 'data',
          type: 'bytes',
        },
        {
          name: 'nonce',
          type: 'uint256',
        },
        {
          name: 'batchId',
          type: 'uint256',
        },
      ],
    };

    const domain = {
      name: 'MultiSigAccount',
      version: '1.0',
      chainId: chainId,
      verifyingContract: fromAddress,
    };
    const signature = await signTypedDataWithWrappedPayload({
      types,
      primaryType: 'Execute',
      domain,
      message: signPayloadMessage,
    });

    return signature;
  };

  return { signSingleCallTypedData };
};

export default useSingleCallSign;
